import React from 'react'
import styled, { css } from 'styled-components'

export type TitleProps = React.PropsWithChildren<{
  subline?: string | React.ReactNode
  white?: boolean
  className?: string
  /** When selecting bigTitle, the subline will be hidden */
  bigTitle?: boolean
}>
const Title = styled<React.FC<TitleProps>>(({ subline, className, children, bigTitle }) => (
  <h2 className={[className, !!bigTitle && 'large-heading'].filter((x) => !!x).join(' ')}>
    {bigTitle ? (
      children
    ) : (
      <>
        <strong>{children}</strong>
        {!!subline && (
          <>
            <br />
            {subline}
          </>
        )}
      </>
    )}
  </h2>
))<TitleProps>`
  ${({ white }) =>
    white
      ? css`
          color: #fff;
        `
      : ''}
`

export default Title
